import { cn } from "@/lib/utils"
import type { ReactNode, HTMLAttributes } from "react"

export const taskListTheme = {
  blockCard: cn(
    "relative bg-purple-950/65 backdrop-blur-2xl border border-purple-300/40",
    "rounded-3xl p-6 cursor-pointer hover:bg-purple-950/80 hover:border-purple-300/60",
    "transition-all duration-300 hover:-translate-y-1 shadow-xl shadow-purple-500/20"
  ),

  pageTitle: "text-3xl font-bold text-white mb-6",

  emptyState: "text-purple-400 text-center py-10",

  badgeNew: "absolute -top-3 -right-3 bg-emerald-500 text-white px-3 py-1 rounded-2xl text-sm font-bold shadow-lg",
  badgeUnread: "absolute -top-3 -left-3 bg-orange-500 text-white rounded-2xl w-10 h-10 flex items-center justify-center text-lg font-bold shadow-lg animate-pulse",

  filterContainer: "flex items-center justify-between mb-6 flex-wrap gap-4",

  selectTrigger: cn(
    "bg-purple-950/70 backdrop-blur-2xl border border-purple-300/40 text-white",
    "hover:border-purple-400 focus:border-purple-400 focus:ring-purple-400",
    "rounded-3xl px-5 py-3 transition-all"
  ),
  selectContent: "bg-purple-950/90 backdrop-blur-2xl border border-purple-300/40 text-white shadow-2xl rounded-3xl",

  tabsList: "inline-flex h-9 items-center justify-center rounded-2xl p-1 bg-purple-950/60 border border-purple-300/30",
  tabTrigger: cn(
    "inline-flex items-center justify-center whitespace-nowrap rounded-[14px] px-5 py-1.5 text-sm font-medium transition-all",
    "data-[state=active]:bg-gradient-to-r data-[state=active]:from-purple-500 data-[state=active]:to-pink-500",
    "data-[state=active]:text-white data-[state=active]:shadow-md"
  ),

  tabTriggerBlocks: cn(
    "inline-flex items-center justify-center whitespace-nowrap rounded-[14px] px-5 py-1.5 text-sm font-medium transition-all",
    "data-[state=active]:bg-gradient-to-r data-[state=active]:from-amber-500 data-[state=active]:to-orange-500",
    "data-[state=active]:text-white data-[state=active]:shadow-md"
  ),

  tasksGrid: "grid grid-cols-1 md:grid-cols-2 gap-10",
} as const

export function BlockCard({
  children,
  onClick,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement> & { onClick?: () => void }) {
  return (
    <div
      className={cn(taskListTheme.blockCard, className)}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  )
}

export function TaskListHeader({ children }: { children: ReactNode }) {
  return <div className={taskListTheme.filterContainer}>{children}</div>
}